<template>
  <div class="offline-session-times">
    <v-container v-if='!invalidSession'>
      <v-layout justify-start style='color: black; background-color: white; padding: 1vh 0 0 1vh;'>
        <h2>{{ sessionName }}</h2>
      </v-layout>
      <v-data-table
        :headers='solverTimesHeader()'
        :items='solverTimesData()'
        hide-default-footer
        hide-default-header>
        <template v-slot:header='{props}'>
          <tr>
            <th v-for='header in props.headers' :key='header.id' style='text-align:center' :class='header.class' @click='addNewOwner(header.id, header.text)'>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:item='{item}'>
          <tr>
            <td> {{ item.num }} </td>
            <td v-for='(time, index) in item.times' :key='index'>
              <!-- use the index to find the solverId which is used for updating solve metadata -->
              <offline-session-single-time v-if='item.pos >= 0'
                :time='time'
                :solverId='solvers[item.indexMap[index]]._id'
                :scrambleId='solves[item.pos]._id'
                :scramble='solves[item.pos].scramble'
                :average='false'
                @open-dialog="$emit('open-dialog')" @close-dialog="$emit('close-dialog')"
                @add-time='addTimeToSession'/>
              <offline-session-single-time v-else :time='time' :average='true' />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <div v-if='invalidSession'> Invalid Session! Either you're not properly logged in or we couldn't find a session with this link... </div>
  </div>
</template>

<script>
import OfflineSessionSingleTime from '@/components/OfflineSessionSingleTime'
export default {
  name: 'offline-session-times',
  data () {
    return {
      solvers: [], // TODO: add solver uuid for v-bind and to avoid name conflicts, allow people to change name, etc.
      solves: [],
      sessionName: '',
      owners: [],
      invalidSession: false,

      // allow new data to overwrite the existing one (should be false when timer is running)
      // store the synced data in a queue until stop-timer is emitted by timer-base
      syncData: true,
      newDataQueue: []
    }
  },
  methods: {
    initSessionTimes () {
      this.invalidSession = false
      this.solvers = [{_id: this.$store.state.solverId, solver: this.$store.state.solver}]
      this.solves = []
      this.owners = [{_id: 'x', name: this.$store.state.solver, ownerId: this.$store.state.solverId}]
      this.sessionName = 'Sample Session'

      if (this.solves.length === 0) {
        this.$store.commit('setScramble', 'No scrambles found yet. Press next to create one')
      } else {
        this.$store.commit('setScramble', this.solves[this.solves.length - 1].scramble)
        this.$store.commit('setScrambleId', this.solves[this.solves.length - 1]._id)
      }
    },
    addNewOwner (newOwnerId, newOwnerName) {
      let res = confirm('You are about to make ' + newOwnerName + ' an owner for this session. They will be able to generate new scrambles but cannot invite new users, change the password, or add new owners. You will still be an owner. THIS CANNOT BE UNDONE. Press OK to confirm')
      if (res === true) {
        alert('New owners cannot be added in the sample session')
      }
    },
    getSolverPosition (solverId) {
      let pos = -1
      for (let i = 0; i < this.solvers.length; i++) {
        if (this.solvers[i]._id === solverId) {
          pos = i
          break
        }
      }
      return pos
    },
    addTimeToSession (params) {
      if (!this.syncData) {
        this.newDataQueue.push({
          type: 'time',
          solverId: params.solverId,
          scrambleId: params.scrambleId,
          time: params.time
        })
        return
      }

      // invalid solverId
      let pos = this.getSolverPosition(params.solverId)
      if (pos === -1) {
        return
      }

      for (let i = 0; i < this.solves.length; i++) {
        if (this.solves[i]._id === params.scrambleId) {
          if (this.solves[i].times.length <= pos) {
            this.solves[i].times = this.solves[i].times.concat(Array(pos - this.solves[i].times.length + 1).fill({ time: 0, plusTwo: false, DNF: false, comment: '' }))
          }
          this.solves[i].times[pos] = params.time
          this.$forceUpdate() // TODO: is force update efficient or can we use this.$set for efficiency?
          return
        }
      }
      // TODO: if this is reached, there is an inconsistent scramble, ie, client didn't receive a scramble that exists
    },
    addSolverToSession (solver) {
      if (!this.syncData) {
        this.newDataQueue.push({
          type: 'solver',
          solver: solver.solver,
          solverId: solver.solverId
        })
        return
      }

      for (let i = 0; i < this.solvers.length; i++) {
        if (this.solvers[i]._id === solver.solverId) {
          return
        }
      }
      this.solvers.push({
        _id: solver.solverId,
        solver: solver.solver
      })
    },
    addScrambleToSession (scramble) {
      if (!this.syncData) {
        this.newDataQueue.push({
          type: 'scramble',
          scramble: scramble.scramble,
          scrambleId: scramble.scrambleId
        })
        return
      }

      this.$store.commit('setScramble', scramble.scramble)
      this.$store.commit('setScrambleId', scramble.scrambleId)

      for (let i = 0; i < this.solves.length; i++) {
        if (this.solves[i]._id === scramble.scrambleId) {
          return
        }
      }
      this.solves.push({
        _id: scramble.scrambleId,
        scramble: scramble.scramble,
        times: Array(this.solvers.length).fill({ time: 0, plusTwo: false, DNF: false, comment: '' })
      })
    },
    overwriteData () {
      // TODO: fix this to remove the timeout
      // setTimeout to give UI some time to catch up before doing work
      setTimeout(() => {
        this.syncData = true
        while (this.newDataQueue.length !== 0) {
          let data = this.newDataQueue.shift()
          if (data.type === 'time') {
            this.addTimeToSession(data)
          } else if (data.type === 'solver') {
            this.addSolverToSession(data)
          } else if (data.type === 'scramble') {
            this.addScrambleToSession(data)
          }
        }
      }, 350)
    },
    averageOfN (N) {
      var sumOfN = Array(this.solvers.length).fill([])
      var numSolves = Array(this.solvers.length).fill(0)
      for (let i = this.solves.length - 1; i >= Math.max(this.solves.length - 5 * N, 0); i--) {
        for (let j = 0; j < this.solves[i].times.length; j++) {
          if (numSolves[j] === N || (this.solves[i].times[j].time === 0 && !this.solves[i].times[j].DNF)) continue
          if (this.solves[i].times[j].DNF) sumOfN[j].push(Infinity)
          else if (this.solves[i].times[j].plusTwo) sumOfN[j].push(this.solves[i].times[j].time + 2)
          else sumOfN[j].push(this.solves[i].times[j].time)
          numSolves[j]++
        }
      }
      var avgOfN = []
      for (let i = 0; i < this.solvers.length; i++) {
        if (numSolves[i] === N) {
          let sum = 0
          sumOfN[i].sort()
          // remove the lowest and highest solve
          for (let j = 1; j < N - 1; j++) {
            sum += sumOfN[i][j]
          }
          avgOfN.push({time: sum / (N - 2)})
        } else {
          avgOfN.push({time: 0})
        }
      }
      return avgOfN
    },
    // data for table header
    solverTimesHeader () {
      let solverPosition = this.getSolverPosition(this.$store.state.solverId)
      if (solverPosition === -1) {
        return []
      }

      let names = []
      names.push({
        text: '#',
        id: 'num',
        align: 'center',
        sortable: false
      })
      for (let i = 0; i < this.solvers.length; i++) {
        names.push({
          text: this.solvers[i].solver + (this.owners.some((a) => { return this.solvers[i]._id === a.ownerId }) ? '♛' : ''),
          id: this.solvers[i]._id,
          align: 'center',
          sortable: false,
          class: this.solvers[i]._id === this.$store.state.solverId ? 'bold-solver' : ''
        })
      }
      return [names[0]].concat([names[solverPosition + 1]]).concat(names.slice(1, solverPosition + 1)).concat(names.slice(solverPosition + 2))
    },
    // data for table data
    solverTimesData () {
      let solverPosition = this.getSolverPosition(this.$store.state.solverId)
      if (solverPosition === -1) {
        return []
      }
      let data = new Array(this.solves.length + 2)
      let ao5 = this.averageOfN(5)
      let ao12 = this.averageOfN(12)
      data[0] = {
        num: 'Ao5',
        times: [ao5[solverPosition]].concat(ao5.slice(0, solverPosition)).concat(ao5.slice(solverPosition + 1)),
        pos: -2
      }
      data[1] = {
        num: 'Ao12',
        times: [ao12[solverPosition]].concat(ao12.slice(0, solverPosition)).concat(ao12.slice(solverPosition + 1)),
        pos: -1
      }

      // Reverse the list to display solves in reverse chronological order with latest solve at the top
      let j = 2
      for (let i = this.solves.length - 1; i >= 0; i--, j++) {
        // let times = this.solves[i].times.concat(new Array(this.solvers.length - this.solves[i].times.length).fill(0))
        let times = this.solves[i].times
        let indexMap = Array(this.solvers.length).fill(0)
        for (let k = 0; k < indexMap.length; k++) {
          indexMap[k] = k
        }
        data[j] = {
          num: i + 1,
          times: [times[solverPosition]].concat(times.slice(0, solverPosition)).concat(times.slice(solverPosition + 1)),
          indexMap: [indexMap[solverPosition]].concat(indexMap.slice(0, solverPosition)).concat(indexMap.slice(solverPosition + 1)),
          pos: i
        }
      }
      return data
    }
  },
  created () {
    this.initSessionTimes()
  },
  components: {
    OfflineSessionSingleTime
  }
}
</script>

<style>
.bold-solver {
  font-weight: bold !important;
  font-size: 1em !important;
  color: black !important;
}
</style>
